import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import get from 'lodash/get';
import {push as changeURL} from 'react-router-redux';
import DocumentTitle from 'react-document-title';
import {Helmet} from 'react-helmet';

import resourceId from '~/misc/resourceId';
import LoadCard from '~/components/search/results/LoadCard';
import mapDispatch from '~/misc/mapDispatch';
import Spinner from '~/components/common/Spinner';
import Price from '~/components/common/Price';
import AgeLabel from '~/components/AgeLabel';
import SimilarLoads from './SimilarLoads/'
import {
  resourcesLoadSaveBroker,
  resourcesLoadRemoveBroker,
} from '~/modules/resources/actions';
import { getMyBookingsAction } from '~/modules/bookings/action';
import { track } from '~/misc/metrics';
import { getLocation } from "~/misc/actionLocation";
import sharedCSS from '../shared.css';
import css from './index.css';
import {modalChange} from "~/modules/modal/actions";
import * as modes from "~/modules/modal/modes";
import { webSearchBuilder } from '~/pages/EmailCampaign/uilts';
import { getUrlQeury } from '~/misc/formatUrlquery';
import { humanLowerCaseToId } from '~/misc/equipment';
import { platformParser } from '~/pages/EmailCampaignNew/uilts';
import { removeQuery } from '~/misc/getQuery';
import  deeplink  from '~/misc/deeplink';
import { jumper } from '~/pages/EmailCampaignNew/uilts';
const isMiss = (key) => ['shipments had been deleted', 'can not find shipments'].includes(key)

const openDeeplink = (id) => {
  const [isMobile] = removeQuery(['isMobile']);
  
  if(isMobile) {
    setTimeout(()=> {
      window.location.href = deeplink.openDetail({id});
    }, 5000)
  }
} 

const similarLoadsItemBuilder = (loadsDetail) => {
  if(!loadsDetail) return ''
  const {
    pickLat,pickLng, pickUpDate,type
  } = loadsDetail
  return {
    from_location: {
      lat: pickLat,
      lng: pickLng
    },
    from_date_local: pickUpDate,
    equipment: type && type.length
      ? type.split(",").map((e) => humanLowerCaseToId[e])
      : [],
    book_now: true,
    load_size: 'full'
  }
}

const LoadCovered = ({
  postTruck
}) => {
  return (
    <div className={css.covered}>
      <div className={css.coveredIcon}>
        <img src="/assets/loadCovered.svg" alt="" />
      </div>
      <div className={css.coveredTitle}>
        Sorry, the load has been covered.
      </div>
      {
        postTruck && <div className={css.coverDesc}> 
          You may post truck and let loads find you.
        </div>
      }
      {
        postTruck && <div className={css.coverButton} onClick={postTruck}>
          Post Truck
        </div>
      }
    </div>
  )
}

const Premium = ({gotoMembership}) => {
  return (
    <div className={css.premium}>
      <div className={css.premiumTitle}>Truckloads Premium</div>
      <div className={css.premiumContent}>
        <div className={css.premiumDesc}>
          See Your Negotiation Power for the Truck Lanes
        </div>
        <div className={css.premiumIcon}>
          <img src="/assets/loadAnalysis.png" alt="" />
        </div>
        <div className={css.coverButton} onClick={gotoMembership}>
          View Lane Analysis
        </div>
      </div>
    </div>
  )
}


const getTitle = (item) => item ?
  `${item.equipment.join(' ')} Loads From ${item.from_state}/${item.from_city} To ${item.to_state}/${item.from_city}` :
  'Find High Paying Loads Freight Flatbed Hot shot Reefer Van Step Deck Loads - Truckloads';
const getDescription = (originName) => originName ?
  `Find high paying Loads from or to ${originName}. We provide free matching service for carriers and brokers/shippers.` :
  `Find truck loads to haul from Alabama, Alaska, American Samoa, Arizona, Arkansas, California, Colorado, Connecticut, Delaware, District Of Columbia, Federated States Of Micronesia, Florida, Georgia, Guam, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Maine, Marshall Islands, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana, Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina, North Dakota, Northern Mariana Islands, Ohio, Oklahoma, Oregon, Palau, Pennsylvania, Puerto Rico, Rhode Island, South Carolina, South Dakota, Tennessee, Texas, Utah, Vermont, Virgin Islands, Virginia, Washington, West Virginia, Wisconsin, Wyoming`;
const getKeyword = (item) => `Truck Loads Freight Flatbed Hot shot Reefer Van Step Deck Loads freight loadboard Owner Operator Trucker Job Backhaul From ${item.from_state}/${item.from_city} To ${item.to_state}/${item.from_city} Loads ${item.id}`;

class LoadPage extends React.Component {
  constructor(props){
    super(props);
    const query = new URLSearchParams(window.location.search);
    const loadsearch  = query.get('loadSearchQuery');
    const autoAction = query.get('autoAction');
    //const campaignQueryObj = loadsearch ?  JSON.parse(window.atob(loadsearch)) : '';
    this.state = {
      matchItem : loadsearch ,
      autoAction,
      loginToken:  query.get('token'),
    }
  } 

  componentWillMount() {
    const query = getUrlQeury()
    if(this.props.shouldPopSignUp) {
      this.props.signUp()
    }
    this.props.getBookings();
    track("view_load_detail", {
      source: query.source || ''
    })
  }
  goBack = () => {
    const { goTo } = this.props;
    const query = new URLSearchParams(window.location.search);
    const backTarget = query.get('back');
    goTo(backTarget || '/');
  }

  componentWillReceiveProps( nextProps) {
    const { loading, error } = nextProps;
  }
  componentWillMount() {
    const { id } = this.props
    openDeeplink(id);
  }
  render() {
    return LoadPageFunc({...this.props, goBack: this.goBack, ...this.state})
  }
}

const LoadPageFunc = ({
  token, accountIsLogin, account, accountLevel, item, id, loading, error, shouldPopSignUp, signUp,
  goToRoot, properAge, bookingLoad, resourcesLoadSaveBroker, resourcesLoadRemoveBroker, goBack ,showUpgradeToEst,showUltimateUpgradeToEst,matchItem, autoAction, loginToken
}) => {
  let saveBrokerFun = (data) => {
    resourcesLoadSaveBroker({...data, loadId: id});
  };
  let removeBrokerFun = (data) => {
    resourcesLoadRemoveBroker({...data, loadId: id});
  };
  return (
    <div className={cs(sharedCSS.wideStretchable, sharedCSS.box, sharedCSS.unpadded, css.main)}>
      {
        item && <DocumentTitle title={getTitle(item)}/>
      }

      {item && <Helmet>
          <meta
            name='description'
            content={getDescription(item.from_city)}
          />
          <meta
            name='keyword'
            content={getKeyword(item)}
          />
        </Helmet>
      }
      {item && !shouldPopSignUp && (item.deleted || item.expired)
        && <SimilarLoads i={item} topShow={true}/>
      }
      <div className={css.linkWrap}>
        <a className={css.link} onClick={goBack}>← search</a><br/>
      </div>
      <h1 className={css.header}>
        <span className={css.headerMain}>Load #{id}</span>
        {item && (
          <span className={css.headerDetails}>
            <Price value={item.target_price}/>
            <AgeLabel properAge={properAge} deleted={item.deleted} bookingLoad={bookingLoad}/>
          </span>
        )}
      </h1>

      {/* {(loading || error || (token && !accountIsLogin)) && <div className={css.spinner}>
        {error ? (<div style={{width:"max-content"}}> {
          error.message ? error.message === 'shipments had been deleted' ? <LoadCovered></LoadCovered> : error.message : "Error"
        }</div>) : null}
        {(loading || (token && !accountIsLogin)) && <Spinner scalable={true}/>}
      </div>}  */}
      {
        loading && <div className={css.spinner}>
          <Spinner scalable={true}/>
        </div>
      }

      { error && <LoadCovered 
        postTruck={matchItem ? () => {
          jumper().gotoPostTruck({
            loginToken,
            campaignQuery: matchItem,
            campaignQueryObj: matchItem ? JSON.parse(window.atob(matchItem)) : ''
          })
          track("Load Actions", {
            Action: "Post Truck Click",
            Placement: getLocation(),
          })
      } : null}
      ></LoadCovered> }

      {!token
          && item
          && <LoadCard
            item={item}
            query={({})}
            accountLevel={accountLevel}
            isPremium={item.featured}
            deleted={!shouldPopSignUp && (item.deleted || item.expired)}
            saveClick={true}
            hideClick={false}
            collectionTheCompany={saveBrokerFun}
            noCollectionCompany={removeBrokerFun}
            unlockFn={showUpgradeToEst}
            unlockUltimateFn={showUltimateUpgradeToEst}
            isMember={parseInt(accountLevel) >= parseInt(account.premium)}
          />
      }
      {token
          && accountIsLogin
          && item
          && <LoadCard
            item={item}
            query={({})}
            accountLevel={accountLevel}
            autoAction = {()=> {
              removeQuery(["autoAction"])
              return autoAction
            }}
            isPremium={item.featured}
            deleted={!shouldPopSignUp && (item.deleted || item.expired)}
            saveClick={true}
            hideClick={false}
            collectionTheCompany={saveBrokerFun}
            noCollectionCompany={removeBrokerFun}
            unlockFn={showUpgradeToEst}
            unlockUltimateFn={showUltimateUpgradeToEst}
            isMember={parseInt(accountLevel) >= parseInt(account.premium)}
          />
      }
      {item && !item.deleted && !item.expired
        && <SimilarLoads i={item} />
      }
      {error && isMiss(error.message) && matchItem && 
        <div>
          <SimilarLoads i={similarLoadsItemBuilder(JSON.parse(window.atob(matchItem)))} subTitle={"Similar loads You May Like"}/>
        </div> 
      }
      {error && isMiss(error.message) && matchItem && 
        <div>
          <Premium
            gotoMembership={matchItem ? () => {
              jumper().gotoMemberShip({
                loginToken,
                campaignQueryObj: matchItem ? JSON.parse(window.atob(matchItem)) : ''
              });
              track("Load Actions", {
                Action: "Lane Analysis Click",
                Placement: getLocation(),
              })
          } : null}
          ></Premium>
        </div>
      }
    </div>
  );
};

export default connect((state, {params: {id}}) => {
  const loads = get(state, 'resources.byName.load');
  const identity = resourceId('load', {id});
  const {
    loading,
    error,
    item,
  } = get(loads, identity.key) || {};

  const {now: {minute}} = state;

  return {
    token: state.user.token,
    accountIsLogin: state.account.userInfo.isLoading,
    accountLevel: state.account.accountLevel,
    account: state.account,
    shouldPopSignUp:
      !state.user.isLoggedIn &&
      !state.user.loading &&
      state.window.globalParams["anon"] === "true",
    item,
    loading,
    error,
    id,
    bookingLoad: item && item.book_now,
    properAge: item && Math.max(minute - item.created_at, 0),
  };
}, mapDispatch({
  goTo: (props, path) => changeURL(path),
  resourcesLoadSaveBroker: (props, data) => resourcesLoadSaveBroker(data),
  resourcesLoadRemoveBroker: (props, data) => resourcesLoadRemoveBroker(data),
  signUp: () => modalChange(modes.SIGNUP_V2, {type: 'pop_upgrade_to_new_standard'}),
  getBookings: (props) => getMyBookingsAction(),
  showUpgradeToEst :(props) => {
    const eventName =
      window.location.href.indexOf("searchloads") >= 0
        ? "Est.Price"
        : "Est.Price_inpage";
    track("est_price", {
      count: 1,
    });
    return modalChange("pop", {
      source: eventName,
      type: "pop_upgrade_to_premium_est",
    });
  },
  showUltimateUpgradeToEst :(props,clickType) => {
    console.log('clickType',clickType)
    let eventName = ''
    
    switch (clickType) {
      case 'ratio':
        eventName = window.location.href.indexOf("searchloads") >= 0
        ? "load_capacity_ratio"
        : "load_capacity_ratio_inpage";
        break;
      case 'indicator':
        eventName = window.location.href.indexOf("searchloads") >= 0
        ? "load_capacity_indicator"
        : "load_capacity_indicator_inpage";
        break;
      default:
        break;
    }
      
    track(eventName, {
      count: 1,
    });
    return modalChange("pop", {
      source: eventName,
      type: "pop_upgrade_to_new_professional",
    });
  }
}))(LoadPage);



// WEBPACK FOOTER //
// ./src/components/LoadPage/index.js